import { useShallow } from "zustand/react/shallow";

import { SuperAdminDashboard } from "@pages/dashboard";
import { useUserStore } from "@/stores/userStore";
import { StaffDashboard } from "@pages/dashboard/staffDashboard";
import { IRole } from "@/interfaces";
import { FacultyMemberDashboard } from "@pages/dashboard/facultyMemberDashboard";

export function App() {
  const role = useUserStore(useShallow((state) => state.role));

  if (!role) return <></>;

  if (role === IRole.FACULTY_MEMBER) return <FacultyMemberDashboard />;
  if (role === IRole.STAFF) return <StaffDashboard />;
  if (role === IRole.DEPARTMENT_STAFF) return <StaffDashboard />;

  return <SuperAdminDashboard />;
}
